import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {GroupId, GroupObject} from '../types';

/**
 * `getGroupObjects` request params
 * (what is used to send to server)
 */
export interface GetGroupObjectsRequestOptions {
	ids: GroupId[];
}

/**
 * `getGroupObjects` request
 * (what gets sent to the server)
 */
export type GetGroupObjectsRequest = [GetGroupObjectsRequestOptions['ids']];

/**
 * `getGroupObjects` response
 * (what comes back from the server)
 */
export type GetGroupObjectsResponse = SuccessResponse<GroupObject[]>;

/**
 * `getGroupObjects` result
 * (what is utilized from the server response)
 */
export type GetGroupObjectsResult = {
	id: GroupId;
	name: string;
	userCount: number;
	hasAccessFilters: boolean;
}[];

export const getGroupObjectsEndpoint = 'getGroupObjects';

/**
 * Get groups by ids
 * @param fetchParams Fetch params
 */
export const getGroupObjects = async (
	{ids}: GetGroupObjectsRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: GetGroupObjectsRequest = [ids];

	return client
		.post<GetGroupObjectsResponse>(getGroupObjectsEndpoint, requestParams, {
			signal,
		})
		.then((response) =>
			response.data.result.map((group) => ({
				id: group.groupId,
				name: group.name,
				userCount: 0,
				hasAccessFilters: false,
			})),
		);
};

export default getGroupObjects;
